module.exports = __webpack_public_path__ + "static/media/notification_icon.2b9487fc.svg";